import React from 'react'
import machine2 from '../../assets/paint_sprayers/x630.JPG'
import machine3 from '../../assets/paint_sprayers/X1080.jpg'
import machine1 from "../../assets/catalogue/fastshot.jpeg";

import contract from '../../assets/paint_sprayers/contract_paint.png'
function Machines() {
  return (
      <div>
    <div id='machines'>
        <img src={machine1}/>
        <img src={machine2}/>
        <img src={machine3}/>

    </div>
    
    <div className="pslast_section">
    
        <div className="psblue-card">
       
          <h2 id="psblue-card-title">
          LOOKING FOR OUR SELECTION OF CONTRACTOR PAINT SPRAYERS?
          </h2>
          <p id="blue-content">
          Whether you’re a contractor focused on small residential or a large contractor tackling the biggest projects every day, Pradco offers you the best, most extensive line of painting equipment to meet your needs.
          </p>
          <a href='/product_catalogue'><button id="psblue_btn">View Paint Sprayers
          </button></a>
        </div>
        <img src={contract} id='blue-img'/>
      </div>

    </div>
  )
}

export default Machines